import React from 'react';
import '../../../styles/index.sass'
import styles from './PlatformAdded.module.scss';

import api from '../../../helpers/api';
import { $t } from '../../../helpers/translator';
import Modal from '../../miscellaneous/Modal/Modal';
import Loader from '../../miscellaneous/Loader/Loader';

class PlatformAdded extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            newMachines: null,
            currentMachine: null,
            showNewMachinesModal: false,

            machineId: '',
            machineName: '',

            errorText: ''
        };
    }

    async componentDidMount() {
        try {
            let newMachines = await api.get('platform/new');
            // console.log('newMachines', newMachines)
            if (newMachines && newMachines.data && newMachines.data.data && newMachines.data.data.length) {
                this.setState({
                    newMachines: newMachines.data.data,
                    showNewMachinesModal: true,
                    currentMachine: newMachines.data.data[0]
                }, () => {
                    // console.log('>>statet', this.state);
                });
            }
        } catch (e) {
            console.error('err getting new machines list', e);
        }
    }

    async savePlatform() {
        if (this.state.errorText) {
            return;
        }

        this.setState({ loading: true }, async () => {
            try {
                let payload = {
                    machineId: this.state.currentMachine.id,
                    machineName: this.state.currentMachine.name
                };

                let res = await api.post('platform/new/save', payload);
            } catch (e) {
                console.error('err adding to clinic', e);
            } finally {
                this.setState({ loading: false }, () => this.closeModals());
            }
        });

    }

    nameChangeHandler(e) {
        let currentMachine = { ...this.state.currentMachine };
        currentMachine.name = e.target.value;

        let errorText = '';
        if (currentMachine.name.length < 3) {
            errorText = $t('validation.general.minLength', [3]);
        }
        if (currentMachine.name.length > 30) {
            errorText = $t('validation.general.maxLength', [30]);
        }
        if (!currentMachine.name) {
            errorText = $t('validation.general.required');
        }

        this.setState({
            errorText: errorText,
            currentMachine: currentMachine
        });
    }

    closeModals() {
        this.setState({ showNewMachinesModal: false }, () => {
            let newMachines = this.state.newMachines;
            newMachines.shift();

            this.setState({
                newMachines: newMachines,
                currentMachine: newMachines && newMachines.length ? newMachines[0] : null,
                showNewMachinesModal: !!(newMachines && newMachines.length),
                errorText: ''
            });
        });
    }

    renderForm() {
        return (
            <div>
                {this.state.currentMachine ?
                    <div>
                        <div>
                            <div className={`${styles['rodal-header']} ${styles['mb-10']}`}>{$t('global.machines.newPlatformAdded')}</div>
                            <div>{$t('global.machines.namePlatform')}</div>
                        </div>

                        <div style={{ margin: '30px 0' }}>
                            <div className={`${styles['row-form']}`}>
                                <div>{$t('global.machines.model')}:</div>
                                <div className={`${styles['input-container']} ${styles['gray']}`}>
                                    {this.state.currentMachine.type}
                                </div>
                            </div>

                            <div className={`${styles['row-form']}`}>
                                <div>{$t('global.machines.id')}:</div>
                                <div className={`${styles['input-container']} ${styles['gray']}`}>
                                    {this.state.currentMachine.machine_id}
                                </div>
                            </div>


                            <div className={`${styles['row-form']}`}>
                                <div>{$t('global.machines.name')}:</div>
                                <div className={`${styles['input-container']}`}>
                                    <input name="name"
                                           className={'alma-input'}
                                           type="text"
                                           value={this.state.currentMachine.name}
                                           onChange={(e) => this.nameChangeHandler(e)}/>
                                </div>
                            </div>

                            <div className={`${styles['error-text']} ${(!this.state.errorText ? styles['hidden'] : null)}`}>
                                {this.state.errorText}
                            </div>

                        </div>

                        {this.state.loading ?
                            <Loader/>
                            :
                            <div className={`${styles['row']} ${styles['flex-end']}`}>
                                <div className={this.state.errorText ? 'alma-button-disabled' : 'alma-button'}
                                     onClick={() => this.savePlatform()}>{$t('global.machines.addToClinic')}
                                </div>
                            </div>
                        }
                    </div>
                    :
                    null
                }

            </div>
        );
    }

    render() {
        return (
            <div>
                {
                    this.state.showNewMachinesModal ?
                        <Modal content={this.renderForm()}
                               onClose={this.closeModals.bind(this)}
                               visible={this.state.showNewMachinesModal}
                               closeOnEsc={false}
                               showCloseButton={false}
                               closeMaskOnClick={false}
                        />
                        :
                        null
                }
            </div>
        );
    }
}


export default PlatformAdded;
